// The mobile navigation drawer.

export function initDrawer(): void {
    const drawer = document.querySelector<HTMLElement>('[data-drawer]');
    const toggles = document.querySelectorAll<HTMLElement>('[data-drawer-toggle]');

    if (!drawer) {
        return;
    }

    const setOpen = (open: boolean): void => {
        drawer.hidden = !open;
        document.body.style.overflow = open ? 'hidden' : '';
        toggles.forEach((toggle) => toggle.setAttribute('aria-expanded', String(open)));

        if (open) {
            drawer.querySelector<HTMLElement>('a, button')?.focus();
        }
    };

    toggles.forEach((toggle) => toggle.addEventListener('click', () => setOpen(drawer.hidden)));

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !drawer.hidden) {
            setOpen(false);
            toggles[0]?.focus();
        }
    });

    drawer.addEventListener('click', (event) => {
        const target = event.target as Element | null;

        if (target === drawer || target?.closest('a')) {
            setOpen(false);
        }
    });
}
